import { Injectable } from '@angular/core';
import { AitTransporteController } from 'app/controllers/mob/ait-transporte.controller';
import { RecursoController } from 'app/controllers/mob/recurso.controller';
import { RecursoDTO } from 'app/model/dtos/mob/recurso.dto';
import { LoaderService } from '../loader.service';
import { Arquivo } from '@tivic-team/manager-ts/dist/grl';
import { PagedResponse } from 'app/interface/paged-response.interface';
import { DocumentoArquivoSearch } from '../ptc/documento-arquivo.search';
import { ArquivoSearch } from '../ptc/arquivo.search';

@Injectable({
  providedIn: 'root'
})
export class RecursoService {

  constructor(
    private _recursoController: RecursoController,
    private _aitTransporteController: AitTransporteController,
    private _loaderService: LoaderService
  ) { }


  async get(cdDocumento: number): Promise<RecursoDTO> {
    this._loaderService.show();
    return this._recursoController.get(cdDocumento).finally(() => {
      this._loaderService.hide();
    });
  }

  async getRecurso(cdAit: number, cdDocumento: number): Promise<RecursoDTO[]> {
    this._loaderService.show();
    return this._aitTransporteController.getRecurso(cdAit,cdDocumento).finally(() => {
      this._loaderService.hide();
    });
  }

  async save(recurso: RecursoDTO): Promise<RecursoDTO> {
    this._loaderService.show();
    if (recurso.cdDocumento && recurso.cdDocumento > 0)
      return this._recursoController.update(recurso).finally(() => this._loaderService.hide());
    else
      return this._recursoController.create(recurso).finally(() => this._loaderService.hide());
  }

  async deferir(recurso: RecursoDTO): Promise<RecursoDTO> {
    this._loaderService.show();
    if (recurso.cdDocumento && recurso.cdDocumento > 0)
      return this._recursoController.deferir(recurso).finally(() => this._loaderService.hide());  
  }

  async indeferir(recurso: RecursoDTO): Promise<RecursoDTO> {
    this._loaderService.show();
    if (recurso.cdDocumento && recurso.cdDocumento > 0)
      return this._recursoController.indeferir(recurso).finally(() => this._loaderService.hide());  
  }

  findArquivoRecurso(arquivoSearch?: ArquivoSearch): Promise<PagedResponse<Arquivo>> {
    this._loaderService.show();
    return this._recursoController.findArquivoRecurso(arquivoSearch && arquivoSearch.getFilters()).finally(() => this._loaderService.hide());
  }
  downloadArquivo(cdArquivo: number): Promise<Arquivo> {
    this._loaderService.show();
    return this._recursoController.downloadArquivo(cdArquivo).finally(() => this._loaderService.hide());
}
}
